__turbopack_context__.v({
  "className": "bumbumalbrafont_6ee0ffee-module__UxVDqa__className",
  "variable": "bumbumalbrafont_6ee0ffee-module__UxVDqa__variable",
});
